type Options = {
    process: (path: string) => void
}
/**
 * Looks for paragraphs and sets up observers when scrolled over
 * Sends out the event `hovered` when there's been a change
 * in intersection observation.
 */
export function watchParagraphs(node: HTMLElement, { process }: Options) {
    const observer = new IntersectionObserver(
        (entries) => {
            for (const entry of entries) {
                const path = entry.target.getAttribute("data-notation")
                if (entry.isIntersecting && path) {
                    process(path)
                }
            }
        },
        {
            root: document.getElementsByTagName("MAIN")[0],
            threshold: 0,
            rootMargin: "0% 0% -100% 0%",
        }
    )

    node.querySelectorAll(".title, .paragraph").forEach((e) =>
        observer.observe(e)
    )
    return {
        destroy() {
            observer.disconnect()
        },
    }
}
